import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData {
  name: string;
  message: string;
  manageData: any;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  public dialogName='Delete';
  public isNewDialog = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    if(this.data.manageData && this.data.manageData.dialogName)
    {
      this.dialogName=this.data.manageData.dialogName;
    }

    this.isNewDialog = this.data.manageData && this.data.manageData.isNewDialog ? true : false;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/shared/confirmation-dialog/confirmation-dialog.component.ts